import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CountdownTimer } from "@/components/ui/countdown-timer";
import { useComingSoonStatus } from "@/hooks/useComingSoonStatus";
import { BackgroundAnimation } from "@/components/coming-soon/BackgroundAnimation";
import { HeroSection } from "@/components/coming-soon/HeroSection";
import { SubscriptionForm } from "@/components/coming-soon/SubscriptionForm";
import { SuccessState } from "@/components/coming-soon/SuccessState";
import { SEOMeta } from "@/components/seo/SEOMeta";

export default function ComingSoon() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const { countdownDate } = useComingSoonStatus();

  const handleSubscriptionSuccess = () => {
    setIsSubscribed(true);
  };

  return (
    <>
      <SEOMeta
        title="PayStreem Coming Soon - Revolutionary Music Streaming Platform"
        description="PayStreem is launching soon! Be the first to experience crypto-powered music streaming where artists earn ₦50 per stream. Join our waitlist for exclusive early access to the future of music."
        url="https://www.paystreem.com"
        type="website"
      />
      <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
        <BackgroundAnimation />

        {/* Login Link - Top Right - Fixed for mobile */}
        <div className="absolute top-4 right-4 z-20">
          <Link to="/login">
            <Button
              variant="outline"
              className="bg-white/10 border-white/20 text-white hover:bg-white/20 transition-colors text-xs sm:text-sm px-2 py-1 sm:px-3 sm:py-2 h-auto"
            >
              <LogIn className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
              <span className="hidden xs:inline">Existing User? </span>Login
            </Button>
          </Link>
        </div>

        <Card className="w-full max-w-md relative z-10">
          <CardContent className="p-8 text-center">
            <HeroSection countdownDate={countdownDate} />

            {/* Countdown Timer */}
            {countdownDate && (
              <div className="mb-8">
                <CountdownTimer targetDate={countdownDate} />
              </div>
            )}

            {!isSubscribed ? (
              <SubscriptionForm onSuccess={handleSubscriptionSuccess} />
            ) : (
              <SuccessState />
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
